export { default } from './AlertTitle';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/lab/esm/AlertTitle/index.js
// module id = 1678
// module chunks = 121